// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".head-links[data-v-4ae5571b]{border-top:1px solid #eee;border-bottom:1px solid #eee;padding-bottom:24px;margin-bottom:37.5px}", ""]);
// Exports
module.exports = exports;
